<p>{{ practiceName | uppercase }}</p>
